import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { planManagementQueries } from '@/services/planManagement/planManagement.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useManageOriginalPlanMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('addClubPlan', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await revalidate(['recommendations']);
      await queryClient.invalidateQueries({ queryKey: [...planManagementQueries.all(), 'list'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};

export const useUpdateClubPlanMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('updateClubPlan', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await revalidate(['recommendations']);
      await queryClient.invalidateQueries({ queryKey: [...planManagementQueries.all(), 'list'] });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};

export const useUpdateClubPlanStatus = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('updateClubPlanStatus', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: [...planManagementQueries.all(), 'list'] });
      await revalidate(['recommendations']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
